import { useQuery } from "@tanstack/react-query";
import { api } from "utils/api";
import { getDownloadUrl } from "./functions/getDownloadUrl";

export interface Statement {
    id: string;
    name: string;
    type: string;
    pdf_statement: string;
    url: string;
    created_at: string;
}

export function useStatements({ loanId }: { loanId: string | undefined }) {
    return useQuery({
        queryKey: ["statements", loanId],
        queryFn: () => {
            return api.get<Statement[]>(`/loans/${loanId}/statements`);
        },
        enabled: !!loanId,
        select: (data) => {
            return data.data.map((statement) => {
                return {
                    ...statement,
                    url: getDownloadUrl({ path: statement.pdf_statement }),
                };
            });
        },
    });
}
